<template lang="pug">
	div.fondoModal
		div
			div
				div.card
					div.card-header.bg-danger.text-white(@click="cerrar")
						| Asignar contrato
						button.close
							span(aria-hidden="true") &times;
					div.card-body
						div.input-group.input-group-sm
							div.input-group-addon
								| Buscar
							input.form-control(type="text", @keypress.enter="buscar", v-model="cadena", placeholder="Título/Cliente/Agente")
							div.input-group-append
								button.btn.btn-primary.btn-sm(@click="buscar")
									span.fa.fa-search
					div.table-responsive.text-left
						table.table.table-striped.table-sm
							thead
								tr
									th Fecha
									th Agente
									th Cliente
									th Título
									th Importe
									th
							tbody
								tr(v-for="contrato in listadoContratos", :key="contrato.ID_contrato")
									td {{ contrato.fecha }}
									td {{ contrato.nombreAgente }}
									td {{ contrato.nombreCliente }}
									td {{ contrato.titulo }}
									td {{ contrato.importe | currency('€')}}
									td
										button.btn.btn-secondary.btn-sm(@click="asignalo(contrato)")
											span.fa.fa-check
								tr(v-if="this.listadoContratos.length === 0")
									td.text-center(colspan="6", style="padding-top:30px;")
										b.text-danger
											| No hay contratos
</template>


<script>
import API from '../../services/api'

export default {
	name: 'asocia-contrato',
	data: function () {
		return {
			cadena: null,
			listadoContratos: []
		}
	},

	created () {
		this.buscar()
	},

	methods: {
		buscar () {
			API.buscaContratos({cadena: this.cadena})
				.then(res => {
					this.listadoContratos = res.data.contratos
				})
				.catch(e => {
					console.error(e)
				})
		},
		asignalo (payload) {
			this.$emit('asignar', payload)
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/nueva/asocia-contrato.vue